<template>
    <v-container>
        <bnft-near-wallet-button></bnft-near-wallet-button>
        <v-btn text small @click="commissionButton">Commission a BraNFT™</v-btn>
        <sup>
            <router-link :to="{ name: 'faq', query: { category: 'collector', id: '6240f1138da87400011d613b' }}" class="text-caption" style="text-decoration: none">(What?)</router-link>
        </sup>
        <v-data-table
                      :search="$route.query.search"
                      :headers="headers"
                      :items="commissionBids"
                      item-key="index"
                      sort-by="index"
                      class="elevation-1 mt-16"
                      hide-default-footer
                      :items-per-page="itemsPerPage"
                      :header-props="headerProps"
                      :page.sync="page"
                      group-by="social_id">
            <template v-slot:[`header.social_id`]="{ header }">
                <span class="text-h5">{{ header.text }}</span>
            </template>
            <template v-slot:[`header.bidder_id`]="{ header }">
                <span class="text-h5">{{ header.text }}</span>
            </template>
            <template v-slot:[`header.price`]="{ header }">
                <span class="text-h5">{{ header.text }}</span>
            </template>
            <template v-slot:[`group`]="{ items, group, isMobile }">
                <v-container :class="{ 'pa-0' : $vuetify.breakpoint.mobile }">
                    <v-row>
                        <v-col :class="{ 'pa-0' : $vuetify.breakpoint.mobile }">
                            <v-img :class="{ 'placeholder': isPlaceholderImage(group) }" v-if="$vuetify.breakpoint.mobile" contain max-width="200px" :src="socialNetworkProfilePhoto(group)"></v-img>
                            <div class="d-flex">
                                <v-img :class="{ 'placeholder': isPlaceholderImage(group) }" class="rounded-lg" v-if="!$vuetify.breakpoint.mobile" max-height="200px" max-width="200px" :src="socialNetworkProfilePhoto(group)"></v-img>
                                <div>
                                    <div class="text-h5 ml-4 mr-2 mt-2 grow"> {{ groups[group].username }}
                                        <sup>
                                            <router-link :to="{ name: 'faq', query: { category: 'creator', id: '6244cf928da87400011d6193' }}" class="text-caption" style="text-decoration: none">(Your account?)</router-link>
                                        </sup>
                                    </div>
                                    <v-btn class="ml-4" @click="addUserPhotoButton(group)" v-if="isPlaceholderImage(group)" text small>Add User Photo</v-btn>
                                    <v-btn class="ml-4" @click="event => commissionButton(event, groups[group].network, groups[group].username)" v-else text small>Commission</v-btn>
                                    <bnft-share-menu :url="`https://${tld}/commissions?search=${group}`" @copy="copy(`https://${tld}/commissions?search=${group}`)">
                                        <v-icon small>share</v-icon>
                                    </bnft-share-menu>
                                </div>
                                <bnft-stats-counter v-if="!$vuetify.breakpoint.mobile" class="mb-4"
                                                    :bids="commissionBids.filter(item => item.social_id === group).length"
                                                    :averageBid="`${commissionBidStats(commissionBids.filter(item => item.social_id === group)).averageBid}` | formatNearAmount"
                                                    :totalBidAmount="`${commissionBidStats(commissionBids.filter(item => item.social_id === group)).totalBidAmount}` | formatNearAmount">
                                </bnft-stats-counter>
                                <a class="text-button mr-2" style="text-decoration: none" target="_blank" rel="noopener" :href="socialProfileLink(groups[group])">{{ groups[group].network }} profile</a>

                            </div>
                            <bnft-stats-counter v-if="$vuetify.breakpoint.mobile" class="mb-4"
                                                :bids="commissionBids.filter(item => item.social_id === group).length"
                                                :averageBid="`${commissionBidStats(commissionBids.filter(item => item.social_id === group)).averageBid}` | formatNearAmount"
                                                :totalBidAmount="`${commissionBidStats(commissionBids.filter(item => item.social_id === group)).totalBidAmount}` | formatNearAmount">
                            </bnft-stats-counter>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-expansion-panels accordion multiple>
                                <v-expansion-panel v-for="(bidderIdGroupForSocialId, bidderId) of groupBySocialIdBidderId[group]" v-bind:key="`expansionPanels-${group}-${bidderId}`">
                                    <v-expansion-panel-header v-if="bidderIdGroupForSocialId.length > 1" :ref="`expansionPanelHeader-${group}-${bidderId}`">
                                        <template v-slot:default="{}">
                                            <v-row>
                                                <v-col class="text-h6 d-flex shrink">{{ bidderId }}</v-col>
                                                <v-spacer></v-spacer>
                                                <v-col cols="1" class="text-h6 d-flex justify-center align-center"><span class="text-subtitle-1 font-weight-bold mr-2">Bids:</span> {{ bidderIdGroupForSocialId.length }}</v-col>
                                                <v-col :cols="$vuetify.breakpoint.mobile ? 4 : 1" class="text-h6 d-flex justify-start align-center">
                                                    <icon-base height="20" width="20" viewBox="0 0 100 225" icon-name="near">
                                                        <icon-near iconColor="rgba(0, 0, 0, 1)" />
                                                    </icon-base>
                                                    <span class="text-h5 ml-1">{{ getBidderIdTotalBid(bidderIdGroupForSocialId[0].social_id, bidderIdGroupForSocialId[0].bidder_id).NEAR.toFixed(2) }}</span>
                                                    <sup v-show="getBidderIdTotalBid(bidderIdGroupForSocialId[0].social_id, bidderIdGroupForSocialId[0].bidder_id).USD" class="ml-1">$ {{ getBidderIdTotalBid(bidderIdGroupForSocialId[0].social_id, bidderIdGroupForSocialId[0].bidder_id).USD.toFixed(2) }}</sup>
                                                </v-col>
                                            </v-row>
                                        </template>
                                        <template v-slot:actions>
                                            <v-icon color="primary">
                                                {{ mdiChevronDown }}
                                            </v-icon>
                                        </template>
                                    </v-expansion-panel-header>
                                    <bnft-commission-bid-row v-else showBidderId :isMobile="isMobile" :bidderIdGroupForSocialId="bidderIdGroupForSocialId" :key="`${group}-${bidderId}-${index}`">
                                    </bnft-commission-bid-row>
                                    <v-expansion-panel-content v-if="bidderIdGroupForSocialId.length > 1" :ref="`expansionPanelContent-${group}-${bidderId}`">
                                        <template v-slot:default>
                                            <bnft-commission-bid-row :isMobile="isMobile" :bidderIdGroupForSocialId="bidderIdGroupForSocialId" :key="`${group}-${bidderId}-${index}`">
                                            </bnft-commission-bid-row>
                                        </template>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </v-data-table>
        <div v-if="NODE_ENV !== 'production'">index: {{ index }} count: {{ count }} pageCount: {{ pageCount }} itemsPerPage: {{ itemsPerPage }}</div>
        <v-pagination
                      v-model="page"
                      @input="nextButtonHandler"
                      :next-icon="mdiChevronRight"
                      :prev-icon="mdiChevronLeft"
                      :length="pageCount"></v-pagination>
        <v-dialog v-model="dialog.signup" :content-class="$vuetify.breakpoint.mobile ? 'mobile' : ''" :width="$vuetify.breakpoint.mobile ? '90%' : 640">
            <bnft-request-user-card @close="closeRequestUserCard" :initUsername="username" :initNetwork="network" ref="bnft-request-user-card"></bnft-request-user-card>
        </v-dialog>
    </v-container>
</template>
<style scoped>
.placeholder >>> .v-image__image.v-image__image--cover {
    opacity: 0.2;
}
</style>
<script>
import App from "../App";
import IconBase from "../components/IconBase.vue";
import IconNear from "../components/IconNear.vue";
import BnftStatsCounter from "../components/BnftStatsCounter.vue";
import BnftRequestUserCard from "../components/BnftRequestUserCard.vue";
import BnftCommissionBidRow from "../components/BnftCommissionBidRow.vue";
import BnftNearWalletButton from "../components/BnftNearWalletButton.vue";
import BnftShareMenu from "../components/BnftShareMenu.vue";

import {
    mdiInstagram,
    mdiTwitter,
    mdiFacebook,
    mdiChevronLeft,
    mdiChevronRight,
    mdiChevronDown,
} from "@mdi/js";
import * as nearAPI from "near-api-js";
import bs58 from "bs58";

export default {
    name: "Commissions",
    mixins: App.mixins.filter((mixin) => mixin.name === "copy"),
    filters: {
        formatNearAmount(value) {
            const formatted = nearAPI.utils.format.formatNearAmount(value, 2);
            return parseFloat(formatted);
        },
    },
    methods: {
        getBidderIdTotalBid(social_id, bidder_id) {
            return this.groupBySocialIdBidderId[social_id] &&
                this.groupBySocialIdBidderId[social_id][bidder_id]
                ? this.groupBySocialIdBidderId[social_id][bidder_id].reduce(
                      (acc, cur) => {
                          acc.NEAR = acc.NEAR + parseFloat(cur.price.NEAR || 0);
                          acc.USD = acc.USD + parseFloat(cur.price.USD || 0);
                          return acc;
                      },
                      { NEAR: 0, USD: 0 }
                  )
                : undefined;
        },
        addUserPhotoButton(group) {
            this.network = this.groups[group].network;
            this.username = this.groups[group].username;
            this.dialog.signup = true;
        },
        commissionButton(event, network, username) {
            event;
            this.network = network ? network : undefined;
            this.username = username ? username : undefined;
            this.dialog.signup = true;
        },
        isPlaceholderImage(group) {
            const photo = this.socialNetworkProfilePhoto(group);
            return photo && photo.match(/unsplash/);
        },
        socialIcon(network) {
            switch (network.toLowerCase()) {
                case "instagram":
                    return mdiInstagram;
                case "twitter":
                    return mdiTwitter;
                case "facebook":
                    return mdiFacebook;
                default:
                    return network;
            }
        },
        socialProfileLink(group) {
            const socialId = group;

            switch (socialId.network) {
                case "tiktok":
                    return `https://tiktok.com/@${socialId.username}`;
                case "instagram":
                    return `https://instagram.com/${socialId.username}`;
                case "facebook":
                    return `https://facebook.com/${socialId.username}`;
                default:
                    return `https://${socialId.network}.com/${socialId.username}`;
            }
        },
        commissionBidStats(commissionBids) {
            const stats = commissionBids.reduce(
                (acc, cur) => {
                    acc.bids.push(cur);
                    const bidAmountInYoctoNear =
                        nearAPI.utils.format.parseNearAmount(cur.price.NEAR);
                    acc.totalBidAmount =
                        BigInt(acc.totalBidAmount) +
                        BigInt(bidAmountInYoctoNear);
                    acc.averageBid = BigInt(
                        acc.totalBidAmount / BigInt(acc.bids.length)
                    );
                    return acc;
                },
                {
                    bids: [],
                    totalBidAmount: 0,
                    averageBid: 0,
                }
            );
            return stats;
        },
        nextButtonHandler(page) {
            if (
                this.index < this.count &&
                this.index < page * this.itemsPerPage
            ) {
                this.getCommissionBids(this.index);
            }
        },
        async getCommissionBidsCount() {
            const count = await this.$near.commissionBidsCount();
            this.count = count;
        },
        async getCommissionBids(index, limit) {
            const self = this;
            const commissionBids = await self.$near.commissionBids({
                index: self.index,
                limit,
            });
            if (commissionBids instanceof Error) return;
            const filtered = commissionBids
                .map((bid, index, bids) => {
                    self.index += 1;
                    try {
                        const decoded = Buffer.from(
                            bs58.decode(bids[index].social_id)
                        ).toString();
                        bids[index].network = decoded.split("_")[0];
                        bids[index].username = decoded
                            .split("_")
                            .slice(1)
                            .join("_");
                        self.groups[bids[index].social_id] = {
                            network: decoded.split("_")[0],
                            username: decoded.split("_").slice(1).join("_"),
                        };
                        const nearAmount =
                            nearAPI.utils.format.formatNearAmount(
                                bids[index].price,
                                2
                            );
                        const usdAmount = self.$near.convertToUSD(nearAmount);
                        bids[index].price = {
                            NEAR: nearAmount,
                            USD: usdAmount,
                        };
                        bids[index].icon = self.socialIcon(bids[index].network);
                        return {
                            index: self.index,
                            ...bids[index],
                        };
                    } catch (error) {
                        error;
                        if (!error.message.match(/base58/)) console.log(error);
                    }
                })
                .filter((bid) => bid)
                .filter((bid) => !bid.username.match(/@/))
                .filter((bid) => bid.username);
            const concated = self.commissionBids
                .concat(filtered)
                .map((bid) => {
                    if (!this.groupBySocialIdBidderId[bid.social_id]) {
                        this.groupBySocialIdBidderId[bid.social_id] = {
                            [bid.bidder_id]: [bid],
                        };
                    } else if (
                        !this.groupBySocialIdBidderId[bid.social_id][
                            bid.bidder_id
                        ]
                    ) {
                        this.groupBySocialIdBidderId[bid.social_id][
                            bid.bidder_id
                        ] = [bid];
                    } else {
                        this.groupBySocialIdBidderId[bid.social_id][
                            bid.bidder_id
                        ].push(bid);
                    }
                    return bid;
                })
                .sort(
                    (a, b) =>
                        a.social_id.charCodeAt(0) - b.social_id.charCodeAt(0)
                );
            self.commissionBids = concated;
        },
        socialNetworkProfilePhoto(group) {
            const self = this;
            const network = this.groups[group].network;
            const username = this.groups[group].username;
            if (this.downloading[`${network}_${username}`])
                return this.photos[`${network}_${username}`];
            this.downloading[`${network}_${username}`] = Date.now();
            (async () => {
                const data = await this.$backend.socialNetworkProfilePhoto(
                    network,
                    username
                );
                if (data && data.photo) {
                    self.$set(
                        self.photos,
                        `${network}_${username}`,
                        data.photo.https
                    );
                    console.log(self.photos[`${network}_${username}`]);
                }
            })();
            return this.photos[`${network}_${username}`];
        },
        closeRequestUserCard() {
            this.$router
                .replace({ "query.transactionHashes": undefined })
                .catch(() => {});
        },
    },
    components: {
        IconBase,
        IconNear,
        BnftStatsCounter,
        BnftRequestUserCard,
        BnftCommissionBidRow,
        BnftNearWalletButton,
        BnftShareMenu,
    },
    data() {
        return {
            NODE_ENV: process.env.NODE_ENV,
            headers: [
                {
                    text: "Creator's Social Network Username",
                    align: "start",
                    value: "social_id",
                    groupable: true,
                },
                {
                    text: "Commission Bidder",
                    value: "bidder_id",
                    groupable: false,
                },
            ],
            commissionBids: [],
            mdiInstagram,
            mdiTwitter,
            mdiFacebook,
            mdiChevronLeft,
            mdiChevronRight,
            mdiChevronDown,
            headerProps: {},
            photos: {},
            page: 1,
            count: 0,
            itemsPerPage: 100,
            index: 0,
            groups: {},
            downloading: {},
            dialog: {
                signup:
                    this.$route.query.transactionHashes ||
                    this.$route.query.state ||
                    this.$route.query.commission
                        ? true
                        : false,
            },
            network: null,
            username: null,
            groupBySocialIdBidderId: {},
        };
    },
    computed: {
        pageCount() {
            return this.count > 0
                ? Math.ceil(this.count / this.itemsPerPage)
                : 0;
        },
    },
    mounted() {
        const self = this;
        (async () => {
            await self.getCommissionBidsCount();
            self.getCommissionBids(this.index, this.itemsPerPage);
        })();
        if (
            this.$store.state.commissionState &&
            this.$store.state.commissionState.params
        ) {
            this.$near.commission(
                this.$store.state.commissionState.params,
                true
            );
        }
    },
    watch: {},
};
</script>
